import React from 'react';
import { ToursProvider } from '../../context/dataToursContext';
import { DataExperiencesProvider } from '../../context/dataExperiencesContext';
import HomeContent from './HomeContent';

const Home = () => {
  return (
    <ToursProvider>
      <DataExperiencesProvider>
        <HomeContent />
      </DataExperiencesProvider>
    </ToursProvider>
  );
};

export default Home;
